import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { DsPageContainer } from '@eiv2/design-system';
import { Sidebar } from './Sidebar';
import { SidebarDrawer } from './SidebarDrawer';
import { MobileNavPill } from './MobileNavPill';
import { Header } from './Header';

export function AppLayout() {
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <DsPageContainer>
      <Header onOpenSidebar={() => setDrawerOpen(true)} />
      <SidebarDrawer open={drawerOpen} onClose={() => setDrawerOpen(false)} />
      <div className="flex min-h-[calc(100dvh-4rem)]">
        <Sidebar />
        <main className="min-w-0 flex-1 px-4 py-4 md:px-8 md:py-8">
          <div className="mx-auto flex w-full max-w-[1320px] flex-col gap-4 md:gap-0">
            <div className="md:hidden">
              <MobileNavPill onOpenMenu={() => setDrawerOpen(true)} />
            </div>
            <Outlet />
          </div>
        </main>
      </div>
    </DsPageContainer>
  );
}
